import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexDirection: 'row',
      height: 50,
      paddingLeft: 25,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    groupName: {
      color: theme.palette.themePrimary,
    },
    description: {
      maxWidth: 1000,
      color: theme.palette.neutralDark,
    },
    optionsSection: {
      width: 250,
      height: 30,
      paddingRight: 25,
    },
    groupSelected: {
      backgroundColor: theme.palette.neutralLighter,
    },

    linkHover: {
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
    },
    linkLightHover: {
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
    },
  };
});
